<template>
  <div>
    <!--<b-list-group >
      這裡是銷售管理
    </b-list-group>
    <b-row class="filter">
      <vue-single-select
            v-if="currentLayer!=='admin'"
            class="ml-2 col-md-4 font-small"
            v-model="filterData.SelectedProjectItem"
            placeholder="篩選課程"
            option-label="ticket_project_fullname"
            :options="filterData.TicketProjects"
            :asyncFetch="true"
            :asyncDelayMS=1000
            :maxResults=500
            @search-text-change="loadTicketsByKeyword"
            :required="false"
          ></vue-single-select>
      <date-picker class="col-md-2 font-small" v-model="filterData.sdate" :config="filterData.dateOptions" placeholder="統計查詢起日"/>
      <span class="my-auto mx-2">~</span>
      <date-picker class="col-md-2 font-small" v-model="filterData.edate" :config="filterData.dateOptions" placeholder="統計查詢迄日"/>
      <b-button class="col-2 ml-3" @click="getChartData">更新資料</b-button>
    </b-row>-->
    <populate-form
      formTitle="銷售管理報表"
      fkey="sr01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <!--<b-row>
      <label class="fun-label" v-if="isAdmin" @click.stop="backTo('admin')">票卷銷售數據</label>
      <label class="fun-label" v-if="merchant_id>0" @click.stop="backTo('merchant')">商家數據({{current_merchant_name}})</label>
      <label class="fun-label" v-if="store_id>0">分店數據({{current_store_name}})</label>
    </b-row>-->
    <b-nav tabs>
      <b-nav-item
        v-for="stackItem in stackItems"
        :key="stackItem.target"
        :class="'fun-label'+(currentLayer===stackItem.target?' current-label':'')"
        @click.prevent.stop="backTo(stackItem.target)"
      >
        {{stackItem.layer_name}}
      </b-nav-item>
    </b-nav>
    <b-row v-if="is_detail_tab === false">
      <div class="chart1">
        <sales-view-chart
          :chartData="chartData"
          :chartOptions="modeConfig[currentLayer].chartOptions"
        />
      </div>

      <div class="summary1">
        <b-list-group>
          <b-list-group-item><span class="float-left">期間使用：</span><span class="float-right mr-2">{{chartSummary.recent_use}}</span></b-list-group-item>
          <b-list-group-item v-if="chartSummary.hasOwnProperty('recent_new_sold')"><span class="float-left">期間銷售：</span><span class="float-right mr-2">{{chartSummary.recent_new_sold}}</span></b-list-group-item>
          <b-list-group-item v-if="chartSummary.hasOwnProperty('recent_new_sold')"><span class="float-left">期間退票：</span><span class="float-right mr-2">{{chartSummary.recent_refund}}</span></b-list-group-item>
          <!--<b-list-group-item><span class="float-left">期間開放：</span><span class="float-right mr-2">{{chartSummary.recent_resource_release}}</span></b-list-group-item>-->
          <b-list-group-item><span class="float-left">期間評價：</span><span class="float-right mr-2">{{chartSummary.recent_avg_score}}</span></b-list-group-item>
        </b-list-group>
      </div>
    </b-row>

    <b-row v-else>
        <div style="width:100%; display:flex; flex-direction:row;align-items:center;">
          <div style="width:100%;min-width:50%;" class="chart-container">
              <LineChartGenerator
                :chart-options="chartOptions"
                :chart-data="detail_chart_view"
              >
              </LineChartGenerator>
          </div>

          <div style="width:20%">
            <b-list-group>
                <b-list-group-item v-for="(total,idx) in total_view" :key="idx">
                    <span class="float-left">{{ total_view_key_mapper[total.key] }}：</span>
                    <span class="float-right mr-2">{{ total.value }}</span>
                </b-list-group-item>
            </b-list-group>
          </div>

        </div>
    </b-row>

    <div class="list1" v-if="is_detail_tab === false">
      <sales-view-list
        :items="listItems"
        :fields="modeConfig[currentLayer].listFields"
        :drillDownCallback="goDetail"
        :goRefundDetail="goRefundDetail"
      />
    </div>

    <div v-else>
      <b-table
        :items="detail_table_view" :fields="detail_columns"
      >

      </b-table>
    </div>

    <loading
     :show="Loading.show"
     :label="Loading.label">
    </loading>
  </div>
</template>

<script>

import {
  apiGetTicketProjectList
} from '@/api/AdminManage.js'

import {
  apiGetAdminProductPerformanceView,
  apiGetMerchantProductPerformanceView,
  apiGetStoreProductPerformanceView, 
  apiGetCancelDetail,
} from '@/api/Merchant.js'

import loading from 'vue-full-loading'
import SalesViewChart from './SalesViewChart'
import SalesViewList from './SalesViewList'

// 圖表套件
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)

export default {
  name: 'SalesViewCombo',
  components: {
    SalesViewChart,
    SalesViewList,
    loading,
    LineChartGenerator,
  },
  data: function () {
    return {
      filterData: {
        sdate: this.getDateByStr('',-30),
        edate: this.getDateByStr('',0)
      },
      // 別寫這 之後搬到created或mounted裡,可以處理時間差載入傳下去的資料
      filterOptions: [
        {
          'componentType':'date-picker',
          'title':'篩選起始日',
          'placeholder':'篩選起始日',
          'defaultValue':null,
          'akey':'sdate',
          'col':2,
        },
        {
          'componentType':'date-picker',
          'title':'篩選結束日',
          'placeholder':'篩選結束日',
          'defaultValue':null,
          'akey':'edate',
          'col':2,
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'TicketProjects',
          'asyncFetchCB': this.loadTicketsByKeyword,
          'defaultValue':null,
          'akey':'SelectedProjectItem',
          'optionLabel':'ticket_project_fullname',
          'col':6,
          'placeholder':'挑選只看指定課程',
          'hide':this.currentLayer==='admin',
        },
        {
          'componentType':'b-button',
          'placeholder':'更新',
          'akey':'search',
          'col':2,
          'execCallback':this.getChartData
        },
      ],
      TicketProjects:[],
      Loading: {
        'show': false,
        'label': '努力加載中'
      },
      /*filterData: {
        sdate: null,
        edate: null,
        ticket_project_id:0,
        TicketProjects:[],
        SelectedProjectItem: null,
        dateOptions: {
          format: 'YYYY/MM/DD',
          useCurrent: false,
        }
      },*/
      isAdmin: true,
      dataStack: {}, // don't use array, use object with admin/merchant/store as key so from store back to admin will be easier
      stackItems:[{'layer_name':'票卷銷售數據','target':'admin'}],
      currentLayer: 'admin', // admin/merchant/store
      merchant_id: 0, //admin drilldown to merchant should set this
      current_merchant_name: '',
      store_id: 0, // merchant drilldown to store should set this
      //只有分店登入時才會有這個值,撈分店資料時有這個id(>0)則不用傳merchant_id,否則才要傳
      store_login_merchant_id: 0,
      current_store_name: '',
      chartData: [['111','222','333','444','555','666'],[1,2,3,4,5,6],[3,2,3,4,5,6],[2,2,3,4,5,6]],
      listItems: [],
      chartSummary:{},

      is_detail_tab: false,
      detail_chart_view: {},
      chartOptions: {
          responsive: true,
          maintainAspectRatio: false
      },
      chart_colors: [
        '#ff6384', '#35a2eb', '#fed369', '#4bc0c0'
      ],
      total_view: [],
      total_view_key_mapper: {
        "3t": "3T",
        "buty99": "buty99",
        "line": "Line酷券",
        "shopee": "蝦皮"
      },
      detail_columns: [
        {
          label: '課程名稱',
          key: 'product_name',
          sortable: true
        },
        {
          label: "3T",
          key:"3t",
          sortable: true
        },
        {
          label: "Buty99",
          key:"buty99",
          sortable: true
        },
        {
          label: "Line酷券",
          key:"line",
          sortable: true
        },
      ],
      detail_table_view: []
      
    }
  },
  props: [
    ],
  methods: {
    loadTicketsByKeyword: function (searchText) {
      if (!this.isAdmin && this.$bus.session) {
        for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
          this.$bus.session.ticket_projects[i]['ticket_project_fullname'] = this.$bus.session.ticket_projects[i].ticket_project_name
        }
        // this.filterData.TicketProjects = this.$bus.session.ticket_projects
        this.TicketProjects = this.$bus.session.ticket_projects
        return
      }
      if (this.merchant_id === 0 && searchText === '') {
        // this.filterData.TicketProjects = []
        this.TicketProjects = []
        return
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'get_ticket_project_list',
        'keyword':searchText
      }
      if (this.QueryStartDate) {
        rptParam.search_start_date = this.QueryStartDate
      }
      if (this.QueryEndDate) {
        rptParam.search_end_date = this.QueryEndDate
      }
      if (this.merchant_id) {
        rptParam.merchant_id = this.merchant_id
      }

      if (rptParam.search_start_date) {
        rptParam.search_start_date = rptParam.search_start_date.replaceAll('/', '-')
      }

      if (rptParam.search_end_date) {
        rptParam.search_end_date = rptParam.search_end_date.replaceAll('/', '-')
      }
      let vm = this
      apiGetTicketProjectList(rptParam).then(function(resp){
        let data = resp.data
        // ticket_project_list增加ticket_project_fullname
        for (let i=0;i<data.data.ticket_project_list.length;i++) {
          data.data.ticket_project_list[i]['ticket_project_fullname'] = data.data.ticket_project_list[i].ticket_project_name + '('+ data.data.ticket_project_list[i].product_id + ')'
        }
        // vm.filterData.TicketProjects = data.data.ticket_project_list
        vm.TicketProjects = data.data.ticket_project_list
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          alert(data.msg)
          return
        }
      })
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //     alert(data.msg)
      //     return
      //   }
      //   // ticket_project_list增加ticket_project_fullname
      //   for (let i=0;i<data.data.ticket_project_list.length;i++) {
      //     data.data.ticket_project_list[i]['ticket_project_fullname'] = data.data.ticket_project_list[i].ticket_project_name + '('+ data.data.ticket_project_list[i].product_id + ')'
      //   }
      //   // vm.filterData.TicketProjects = data.data.ticket_project_list
      //   vm.TicketProjects = data.data.ticket_project_list
      // }, this)      
    },
    getChartData: function () {
      this.Loading.show = true
      // 日期未選null時用預設值設定,-90~-1
      let rptParam = {
        'module':'merchant',
        'method':this.modeConfig[this.currentLayer].ApiMethod,
        'report_start_date':this.filterData.sdate?this.filterData.sdate:this.getDateByStr('',-90),
        'report_end_date':this.filterData.edate?this.filterData.edate:this.getDateByStr('',-1),
        'gchart_mode':1
      }
      if (this.currentLayer === 'merchant') {
        rptParam.merchant_id = this.merchant_id
        if (this.filterData.SelectedProjectItem) {
          rptParam.ticket_project_id = this.filterData.SelectedProjectItem.ticket_project_id
        }
        else {
          rptParam.ticket_project_id = 0
        }
      }
      else if (this.currentLayer === 'store') {
        rptParam.merchant_store_id = this.store_id
        if (this.store_login_merchant_id === 0) {
          rptParam.merchant_id = this.merchant_id
        }
        if (this.filterData.SelectedProjectItem) {
          rptParam.ticket_project_id = this.filterData.SelectedProjectItem.ticket_project_id
        }
      }

      if (rptParam.report_start_date) {
        rptParam.report_start_date = rptParam.report_start_date.replaceAll('/', '-')
      }

      if (rptParam.report_end_date) {
        rptParam.report_end_date = rptParam.report_end_date.replaceAll('/', '-')
      }

      let vm = this
      switch (this.currentLayer) {

        case 'admin':
          apiGetAdminProductPerformanceView(rptParam).then(function(resp){
            let data = resp.data
            // eslint-disable-next-line
            // console.log(data)
            const parsedData = vm.normallizeDS(data.data)
            //vm.chartData = data.data.chart_view
            vm.chartData = parsedData.chart_view
            //vm.listItems = data.data.merchant_list_view
            //vm.listItems = data.data[vm.modeConfig[vm.currentLayer].listName]
            vm.listItems = parsedData.list_view
            vm.chartSummary = parsedData.summary_view
            vm.Loading.show = false
          }).catch(function(error){
            let data = error.response.data
            if (data.ok === 0) {
                alert(data.msg)
                vm.Loading.show = false
                return
            }
          })
          break;

        case 'merchant':
          apiGetMerchantProductPerformanceView(rptParam).then(function(resp){
            let data = resp.data
            // eslint-disable-next-line
            // console.log(data)
            const parsedData = vm.normallizeDS(data.data)
            //vm.chartData = data.data.chart_view
            vm.chartData = parsedData.chart_view
            //vm.listItems = data.data.merchant_list_view
            //vm.listItems = data.data[vm.modeConfig[vm.currentLayer].listName]
            vm.listItems = parsedData.list_view
            vm.chartSummary = parsedData.summary_view
            vm.Loading.show = false
          }).catch(function(error){
            let data = error.response.data
            if (data.ok === 0) {
                alert(data.msg)
                vm.Loading.show = false
                return
            }
          })
          break;

        case 'store':
          apiGetStoreProductPerformanceView(rptParam).then(function(resp){
            let data = resp.data
            // eslint-disable-next-line
            // console.log(data)
            const parsedData = vm.normallizeDS(data.data)
            //vm.chartData = data.data.chart_view
            vm.chartData = parsedData.chart_view
            //vm.listItems = data.data.merchant_list_view
            //vm.listItems = data.data[vm.modeConfig[vm.currentLayer].listName]
            vm.listItems = parsedData.list_view
            vm.chartSummary = parsedData.summary_view
            vm.Loading.show = false
          }).catch(function(error){
            let data = error.response.data
            if (data.ok === 0) {
                alert(data.msg)
                vm.Loading.show = false
                return
            }
          })
          break;

          default: 
            console.log('no_target')
      }
      // this.$bus.apiCall(rptParam, function (data, vm) {
      //   if (data.ok === 0) {
      //       alert(data.msg)
      //       vm.Loading.show = false
      //       return
      //     }
      //     // eslint-disable-next-line
      //     // console.log(data)
      //     const parsedData = vm.normallizeDS(data.data)
      //     //vm.chartData = data.data.chart_view
      //     vm.chartData = parsedData.chart_view
      //     //vm.listItems = data.data.merchant_list_view
      //     //vm.listItems = data.data[vm.modeConfig[vm.currentLayer].listName]
      //     vm.listItems = parsedData.list_view
      //     vm.chartSummary = parsedData.summary_view
      //     vm.Loading.show = false
      // },this)
    },
    goDetail(row) {
      if (this.currentLayer === 'admin') {
        this.merchant_id = row.item_id
        this.current_merchant_name = row.item_name
        this.currentLayer = 'merchant'
        this.stackItems.push({
          'layer_name':'商家數據('+row.item_name+')',
          'target':'merchant',
        })
        // go merchant, store current admin data before fetch merchant data
        this.dataStack['admin'] = {
          chartData: this.chartData,
          listItems: this.listItems,
          chartSummary:this.chartSummary
        }
        this.loadTicketsByKeyword('')
      }
      else if (this.currentLayer === 'merchant') {
        this.store_id = row.item_id
        this.current_store_name = row.item_name
        this.currentLayer = 'store'
        this.stackItems.push({
          'layer_name':'分店數據('+row.item_name+')',
          'target':'store',
        })
        // go merchant, store current admin data before fetch merchant data
        this.dataStack['merchant'] = {
          chartData: this.chartData,
          listItems: this.listItems,
          chartSummary:this.chartSummary
        }
      }
      else {
        // store不提供drill down
        return
      }
      this.refreshControl()
      this.getChartData()
    },
    backTo (to) {
      // 沒往上退就不處理(currentLayer不會小於最深那層,故只要判斷等於)
      if (to === this.currentLayer) {
        return
      }
      if (to === 'admin') {
        this.dataStack['merchant'] = null
        this.dataStack['store'] = null
        this.chartData = this.dataStack['admin'].chartData
        this.listItems = this.dataStack['admin'].listItems
        this.chartSummary = this.dataStack['admin'].chartSummary
        this.merchant_id = 0
        this.store_id = 0
        this.current_merchant_name = ''
        this.current_store_name = ''
        this.currentLayer = 'admin'
        this.filterData.SelectedProjectItem = null
        this.filterData.TicketProjects = []
        // restore back to only first
        this.stackItems = [this.stackItems[0]]
        this.is_detail_tab = false
      }
      else if (to === 'merchant') {
        this.dataStack['store'] = null
        this.chartData = this.dataStack['merchant'].chartData
        this.listItems = this.dataStack['merchant'].listItems
        this.chartSummary = this.dataStack['merchant'].chartSummary
        this.store_id = 0
        this.current_store_name = ''
        this.currentLayer = 'merchant'
        if (this.$bus.getRole() === 'admin') {
          this.stackItems = [this.stackItems[0],this.stackItems[1]]
        }
        else {
          // merchant只有兩層,回到第一層只留最前面一個
          this.stackItems = [this.stackItems[0]]
        }
      }
      this.refreshControl()
    },
    normallizeDS(data) {
      // api get data should be processed here to make same interface
      // 雖然這個完全可以在後端做掉,但有時候在前端處理會比較靈活,此功能就在前端寫
      // data的chart_view要洗
      // data的merchant_list_view/store_list_view/duration_list_view要洗
      let normalized_ds = []
      let list_data = data[this.modeConfig[this.currentLayer].listName]
      for (let i=0;i<list_data.length;i++) {
        list_data[i].item_id = list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_id]
        list_data[i].item_name = list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_name]
        delete list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_id]
        delete list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_name]
        normalized_ds.push(list_data[i])
      }
      data[this.modeConfig[this.currentLayer].listName]
      return {
        chart_view: data.chart_view,
        list_view: normalized_ds,
        summary_view: data.summary_view
      }
    },
    refreshControl() {
      // 因control的hide隨著狀態變化,故需額外的方法來更新options的設定(不會變的就不用這麼麻煩)
      for (let i=0;i<this.filterOptions.length;i++) {
        if (this.filterOptions[i].akey === 'SelectedProjectItem') {
          this.filterOptions[i].hide = this.currentLayer === 'admin'
        }
      }
    },
    goRefundDetail: async function(row){  
      let that = this
      let param = {
        start_at: this.filterData.sdate.replaceAll('/', '-'),
        end_at: this.filterData.edate.replaceAll('/', '-'),
        supplier_id: row.supplier_id,
      }

      let result = await apiGetCancelDetail(param).then(function(resp){
        console.log(resp)
        return resp.data
      }).catch(function(error){
        return ''
      })

      if (result === '') {
        return
      }


      result.data.chart_view.datasets.forEach(function(dataset,idx){
        dataset['backgroundColor'] = that.chart_colors[idx]
        dataset['borderColor'] = that.chart_colors[idx]
      })

      this.detail_chart_view = result.data.chart_view
      this.detail_table_view = result.data.table_view

      let total_view_keys = Object.keys(result.data.total_view)
      this.total_view = []
      total_view_keys.forEach(function(key){
        let tmp_total = {
          "key": key,
          "value": result.data.total_view[key]
        }
        that.total_view.push(tmp_total)
      })


      console.log('mr 周 mr 皓')
      console.log(row)
      this.stackItems.push({
        'layer_name': row.item_name,
      })
      this.is_detail_tab = true
      this.merchant_id = row.item_id
      this.current_merchant_name = row.item_name
      this.currentLayer = 'merchant'
      // go merchant, store current admin data before fetch merchant data
      this.dataStack['admin'] = {
        chartData: this.chartData,
        listItems: this.listItems,
        chartSummary:this.chartSummary
      }
      this.loadTicketsByKeyword('')





        // go merchant, store current admin data before fetch merchant data
        // this.dataStack['admin'] = {
        //   chartData: this.chartData,
        //   listItems: this.listItems,
        //   chartSummary:this.chartSummary
        // }
    }
  },
  computed: {
    modeConfig () {
      // 三個模式對應屬性差異設定寫死於此
      return {
        admin: {
          ApiMethod:'getAdminProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 0},
                2: {targetAxisIndex: 0},
                3: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "merchant_list_view",
          listFields: [
            {
              key: 'item_name',
              label: '商家名稱',
              sortable: false
            },
            {
              key: 'recent_new_sold',
              label: '銷售數',
              sortable: true
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            {
              key: 'recent_refund',
              label: '退票數',
              sortable: true
            },
            /*{
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'merchant_id',
            item_name: 'merchant_name'
          },
        },
        merchant: {
          ApiMethod:'getMerchantProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 0},
                2: {targetAxisIndex: 0},
                3: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "store_list_view",
          listFields: [
            {
              key: 'item_name',
              label: '分店名稱',
              sortable: false
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            /*{
              key: 'recent_new_sold',
              label: '銷售數',
              sortable: true
            },
            {
              key: 'recent_refund',
              label: '退票數',
              sortable: true
            },
            {
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'merchant_store_id',
            item_name: 'store_name'
          },
        },
        store: {
          ApiMethod:'getStoreProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "duration_list_view",
          listFields: [
            /*{
              key: 'item_name',
              label: '預約排程',
              sortable: false
            },*/
            {
              key: 'service_name',
              label: '課程名稱',
              sortable: false
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            /*{
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'reservation_schedule_id',
            item_name: 'duration'
          },
        }
      }
    },
  },
  mounted () {
    // 判斷role,總管理就直接用admin抓,若商家的話...則判斷是總管理或分店
    const role = this.$bus.getRole()
    if (role === 'user') {
      return
    } else if (role === 'merchant') {
      this.isAdmin = false
      if (this.$bus.session) {
        if (this.$bus.session.is_super_manage) {
          this.currentLayer = 'merchant'
          this.merchant_id = this.$bus.session.merchant_id
          this.current_merchant_name = this.$bus.session.merchant_name
          this.stackItems = [{
            'layer_name':'商家數據('+this.$bus.session.merchant_name+')',
            'target':'merchant'
          }]
        }
        else {
          this.currentLayer = 'store'
          this.store_id = this.$bus.session.merchant_store_id
          this.store_login_merchant_id = this.$bus.session.merchant_id
          this.current_store_name = this.$bus.session.store_name
          this.stackItems = [{
            'layer_name':'分店數據('+this.$bus.session.store_name+')',
            'target':'store'
          }]

        }
        this.$refs.filterForm.initDefault()
      }
      else {
        return
      }
    }

    // this.filterData.sdate = this.getDateByStr('',-30)
    // this.filterData.edate = this.getDateByStr('',0)
    this.refreshControl()
    this.getChartData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:80%;
  height:280px;
}
.summary1 {
  width:20%;
  margin-left: -5%;
  margin-top:auto;
  margin-bottom:auto;
}
.fun-label {
  margin-top:1px;
  margin-left:1px;
  background-color:lavender;
  box-shadow: 5px 5px 5px;
  margin-right:5px;
}
.fun-label >>> a {
  color:darkblue;
  text-decoration: underline;
}
.current-label {
  cursor:none;
}
.current-label >>> a {
  cursor:not-allowed;
  color:black;
  font-size: medium;
  text-decoration: none;
}

.font-small {
  font-size: 10px;
}
.chart-container {
  height: 300px;
}
.chart-container > div {
  height: 100%;
}
</style>
